module.exports = __webpack_public_path__ + "img/productSatellite_16.2c9d49ce.png";